import type { DateValue } from '@chakra-ui/react';
import { getTimeAsUtcMidday } from 'src/app/core/helpers/date/date';
import { transformDate } from 'src/app/project/shared/date-transformer';
import { EDateFormat } from 'src/app/project/shared/enums/date-format.enum';

const RANGE_SEPARATOR = '~';
const EMPTY_VALUE = '';

export type TDateRange = {
  from: string | null;
  to: string | null;
};

const toLocalDate = (isoDate: string): Date => {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatDateValue = (date: DateValue, dateFormat: EDateFormat): string =>
  transformDate({
    value: getTimeAsUtcMidday(new Date(date.year, date.month - 1, date.day)),
    format: dateFormat,
  });

export const toIsoDate = (epochMs: string | undefined): string | null => {
  if (!epochMs || !Number.isFinite(Number(epochMs))) {
    return null;
  }
  return transformDate({ value: epochMs, format: EDateFormat.ISO });
};

export const toUtcMiddayEpoch = (isoDate: string): string =>
  String(getTimeAsUtcMidday(toLocalDate(isoDate)));

export const parseDateRange = (value: string): TDateRange => {
  const [from, to] = value.split(RANGE_SEPARATOR);
  return { from: toIsoDate(from), to: toIsoDate(to) };
};

export const serialiseDate = (isoDate: string | null): string =>
  isoDate === null ? EMPTY_VALUE : toUtcMiddayEpoch(isoDate);

export const serialiseDateRange = ({ from, to }: TDateRange): string | undefined => {
  if (from === null && to === null) {
    return EMPTY_VALUE;
  }
  if (from === null || to === null) {
    return undefined;
  }
  return `${toUtcMiddayEpoch(from)}${RANGE_SEPARATOR}${toUtcMiddayEpoch(to)}`;
};
